__turbopack_context__.v({
  "actionButton": "DadFcG_actionButton",
  "actionButtonHidden": "DadFcG_actionButtonHidden",
  "circle": "DadFcG_circle",
  "circleFilled": "DadFcG_circleFilled",
  "header": "DadFcG_header",
  "line": "DadFcG_line",
  "progress": "DadFcG_progress",
  "tooltipContent": "DadFcG_tooltipContent",
  "tooltipLink": "DadFcG_tooltipLink",
  "tooltipWrapper": "DadFcG_tooltipWrapper",
});
